import styled from "styled-components"

import { ParadiseLLMActivePrompt } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseLLMActivePrompt"
import { ParadiseLLMPromptBulkTesting } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseLLMPromptBulkTesting"
import { ParadiseLLMPromptVersions } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseLLMPromptVersions"
import { TParadiseLLMPrompt } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import { TabPanel } from "src/ui/Tabs/TabPanel"
import { Tabs } from "src/ui/Tabs/Tabs"

export function ParadiseLLMPrompt({ prompt }: { prompt: TParadiseLLMPrompt }) {
  const tabs = [
    {
      id: "active",
      label: "Active",
      component: <ParadiseLLMActivePrompt prompt={prompt} />,
    },
    {
      id: "versions",
      label: `Versions (${prompt.versions.length})`,
      component: <ParadiseLLMPromptVersions prompt={prompt} />,
    },
    {
      id: "bulk-testing",
      label: "Bulk Testing",
      component: <ParadiseLLMPromptBulkTesting prompt={prompt} />,
    },
  ]

  return (
    <Tabs
      labels={tabs.map((tab) => ({
        label: tab.label,
        id: tab.id,
      }))}
    >
      {tabs.map((tab) => (
        <StyledTabPanel key={tab.id}>{tab.component}</StyledTabPanel>
      ))}
    </Tabs>
  )
}

const StyledTabPanel = styled(TabPanel)`
  height: 100%;
`
